import { createLiveClass, deleteLiveClass, updateLiveClass } from "helpers/batch_helper";
import moment from "moment";
import { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { Button, Row } from "reactstrap";

const localizer = momentLocalizer(moment);

const LClass = ({ liveClasses, loader, setLoader, params, fetchBatchDetails, spanDisplay }) => {
    const [addClassModal, setAddClassModal] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [selectedClass, setSelectedClass] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [liveClass, setLiveClass] = useState({
        title: "",
        description: "",
        classLink: "",
        classTime: "",
        batchId: "",
        id: ""
    });

    // ✅ Handle create or update
    const handleClassSave = async () => {

        console.log(liveClass);
        try {
            setLoader(true);
            const payload = { ...liveClass, batchId: params.id, id: liveClass.id };
            console.log(payload)
            const res = isEditMode
                ? await updateLiveClass(payload)
                : await createLiveClass(payload);

            if (res?.success) {
                toast.success(res?.message);
                fetchBatchDetails();
                setAddClassModal(false);
                setIsEditMode(false);
                setLiveClass({
                    title: "",
                    description: "",
                    classLink: "",
                    classTime: "",
                    batchId: "",
                });
            } else {
                toast.error(res?.message);
            }
        } catch (err) {
            toast.error("Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    // ✅ Delete class
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this class?")) return;
        try {
            setLoader(true);
            const batchId = params.id;
            const res = await deleteLiveClass(id + "/" + batchId);
            if (res?.success) {
                toast.success(res?.message);
                fetchBatchDetails();
                setViewModal(false);
            } else {
                toast.error(res?.message);
            }
        } catch (err) {
            toast.error("Failed to delete class");
        } finally {
            setLoader(false);
        }
    };

    // ✅ Handle edit click (pre-fill modal)
    const handleEdit = (cls) => {
        setLiveClass({
            id: cls.id,
            title: cls.title,
            description: cls.description,
            classLink: cls.classLink,
            classTime: moment(cls.start).format("YYYY-MM-DDTHH:mm"),
        });
        setIsEditMode(true);
        setAddClassModal(true);
        setViewModal(false);
    };

    useEffect(() => {
        console.log(liveClasses)
    }, []);

    return (
        <>
            <div className="row mt-2">
                <div className="col-md-12">
                    <div className="d-flex justify-content-end mb-2">
                        <Button
                            type="button"
                            color="primary"
                            onClick={() => {
                                setIsEditMode(false);
                                setAddClassModal(true);
                            }}
                            className="waves-effect waves-light me-2"
                        >
                            Add Class
                        </Button>
                    </div>

                    {/* ✅ Calendar */}
                    <div style={{ height: "500px" }}>
                        <Calendar
                            localizer={localizer}
                            events={liveClasses}
                            startAccessor="start"
                            endAccessor="end"
                            defaultView="month"
                            views={["month", "day"]}
                            style={{
                                backgroundColor: "#f0f0f0",
                                borderRadius: "8px",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            }}
                            eventPropGetter={() => ({
                                style: {
                                    backgroundColor: "#357edd",
                                    color: "white",
                                    padding: "5px",
                                    borderRadius: "4px",
                                    fontSize: "14px",
                                },
                            })}
                            popup
                            onSelectEvent={(event) => {

                                console.log("fjdkfjkdjfkdj")
                                console.log(event)
                                setSelectedClass(event);
                                setViewModal(true);
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* ✅ View Modal (opens on click) */}
            <Modal show={viewModal} centered size="md">
                <Modal.Header>Live Class Details</Modal.Header>
                <Modal.Body>

                    {selectedClass && (
                        <>
                            <p><strong>Title:</strong> {selectedClass.title}</p>
                            <p><strong>Description:</strong> {selectedClass.description}</p>
                            <p>
                                <strong>Time:</strong>{" "}
                                {moment(selectedClass.start).format("DD MMM YYYY, hh:mm A")}
                            </p>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    <Button color="warning" onClick={() => handleEdit(selectedClass)}>
                        Edit
                    </Button>
                    <Button color="danger" onClick={() => handleDelete(selectedClass.id)}>
                        Delete
                    </Button>
                    <Button
                        color="success"
                        onClick={() =>
                            window.open(selectedClass.classLink, "_blank", "noopener,noreferrer")
                        }
                    >
                        Join
                    </Button>
                    <Button color="secondary" onClick={() => setViewModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* ✅ Add/Edit Modal */}
            <Modal show={addClassModal} size="lg" centered>
                <Modal.Header>
                    {isEditMode ? "Edit Live Class" : "Create Live Class"}
                </Modal.Header>
                <Modal.Body>
                    <Row className="mb-3">
                        <label className="col-md-2 col-form-label">Class Title</label>
                        <div className="col-md-10">
                            <input
                                type="text"
                                className="form-control"
                                value={liveClass.title}
                                placeholder="Enter Class Title"
                                onChange={(e) =>
                                    setLiveClass((p) => ({ ...p, title: e.target.value }))
                                }
                            />
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label className="col-md-2 col-form-label">Description</label>
                        <div className="col-md-10">
                            <input
                                type="text"
                                className="form-control"
                                value={liveClass.description}
                                placeholder="Enter Description"
                                onChange={(e) =>
                                    setLiveClass((p) => ({ ...p, description: e.target.value }))
                                }
                            />
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label className="col-md-2 col-form-label">Class Link</label>
                        <div className="col-md-10">
                            <input
                                type="text"
                                className="form-control"
                                value={liveClass.classLink}
                                placeholder="Enter Class Link"
                                onChange={(e) =>
                                    setLiveClass((p) => ({ ...p, classLink: e.target.value }))
                                }
                            />
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label className="col-md-2 col-form-label">Class Time</label>
                        <div className="col-md-10">
                            <input
                                type="datetime-local"
                                className="form-control"
                                value={liveClass.classTime}
                                onChange={(e) =>
                                    setLiveClass((p) => ({ ...p, classTime: e.target.value }))
                                }
                            />
                        </div>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button color="secondary" onClick={() => setAddClassModal(false)}>
                        Close
                    </Button>
                    <Button color="success" onClick={handleClassSave}>
                        {isEditMode ? "Update Class" : "Create Class"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default LClass;








// import { createLiveClass, deleteLiveClass, updateLiveClass } from "helpers/batch_helper";
// import moment from "moment";
// import { useEffect, useState } from "react";
// import { Calendar, momentLocalizer } from "react-big-calendar";
// import { Modal } from "react-bootstrap";
// import { toast } from "react-toastify";
// import { Button, Row } from "reactstrap";
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import VideoCallIcon from '@mui/icons-material/VideoCall';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import LinkIcon from '@mui/icons-material/Link';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import SubjectIcon from '@mui/icons-material/Subject';
// import { CircularProgress } from "@mui/material";

// const localizer = momentLocalizer(moment);

// const LClass = ({ liveClasses, loader, setLoader, params, fetchBatchDetails, spanDisplay }) => {
//     const [addClassModal, setAddClassModal] = useState(false);
//     const [viewModal, setViewModal] = useState(false);
//     const [selectedClass, setSelectedClass] = useState(null);
//     const [isEditMode, setIsEditMode] = useState(false);
//     const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
//     const [classToDelete, setClassToDelete] = useState(null);
//     const [liveClass, setLiveClass] = useState({
//         title: "",
//         description: "",
//         classLink: "",
//         classTime: "",
//         batchId: "",
//         id: ""
//     });

//     // Reset form
//     const resetForm = () => {
//         setLiveClass({
//             title: "",
//             description: "",
//             classLink: "",
//             classTime: "",
//             batchId: "",
//             id: ""
//         });
//         setIsEditMode(false);
//     };

//     // Handle modal close
//     const handleModalClose = () => {
//         setAddClassModal(false);
//         resetForm();
//     };

//     // ✅ Handle create or update
//     const handleClassSave = async () => {
//         // Validation
//         if (!liveClass.title?.trim()) {
//             toast.error("Class title is required");
//             return;
//         }
//         if (!liveClass.description?.trim()) {
//             toast.error("Class description is required");
//             return;
//         }
//         if (!liveClass.classLink?.trim()) {
//             toast.error("Class link is required");
//             return;
//         }
//         if (!liveClass.classTime) {
//             toast.error("Class time is required");
//             return;
//         }

//         try {
//             setLoader(true);
            
//             // Format the date properly
//             const formattedClassTime = new Date(liveClass.classTime).toISOString();
            
//             const payload = { 
//                 ...liveClass, 
//                 batchId: params.id, 
//                 classTime: formattedClassTime,
//                 id: liveClass.id || undefined
//             };
            
//             console.log("Saving class payload:", payload);
            
//             const res = isEditMode
//                 ? await updateLiveClass(payload)
//                 : await createLiveClass(payload);

//             if (res?.success) {
//                 toast.success(res?.message);
//                 await fetchBatchDetails();
//                 handleModalClose();
//                 setViewModal(false);
//             } else {
//                 toast.error(res?.message || `Failed to ${isEditMode ? 'update' : 'create'} class`);
//             }
//         } catch (err) {
//             console.error("Error saving class:", err);
//             toast.error(err?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoader(false);
//         }
//     };

//     // ✅ Delete class
//     const handleDelete = async () => {
//         if (!classToDelete) return;

//         try {
//             setLoader(true);
//             const res = await deleteLiveClass(classToDelete.id);
            
//             if (res?.success) {
//                 toast.success(res?.message);
//                 await fetchBatchDetails();
//                 setDeleteConfirmModal(false);
//                 setViewModal(false);
//                 setClassToDelete(null);
//                 setSelectedClass(null);
//             } else {
//                 toast.error(res?.message || "Failed to delete class");
//             }
//         } catch (err) {
//             console.error("Error deleting class:", err);
//             toast.error(err?.response?.data?.message || "Failed to delete class");
//         } finally {
//             setLoader(false);
//         }
//     };

//     // ✅ Handle delete confirmation
//     const confirmDelete = (cls) => {
//         setClassToDelete(cls);
//         setDeleteConfirmModal(true);
//     };

//     // ✅ Handle edit click (pre-fill modal)
//     const handleEdit = (cls) => {
//         setLiveClass({
//             id: cls.id,
//             title: cls.title,
//             description: cls.description,
//             classLink: cls.classLink,
//             classTime: moment(cls.start).format("YYYY-MM-DDTHH:mm"),
//         });
//         setIsEditMode(true);
//         setAddClassModal(true);
//         setViewModal(false);
//     };

//     // Open class link
//     const openClassLink = (link) => {
//         if (!link) {
//             toast.error("No class link available");
//             return;
//         }
        
//         let formattedLink = link;
//         if (!formattedLink.startsWith('http://') && !formattedLink.startsWith('https://')) {
//             formattedLink = 'https://' + formattedLink;
//         }
        
//         window.open(formattedLink, '_blank', 'noopener,noreferrer');
//     };

//     // Event styling
//     const eventStyleGetter = (event, start, end, isSelected) => {
//         const now = new Date();
//         const isPast = end < now;
        
//         let backgroundColor = '#28a745'; // Green for upcoming
        
//         if (isPast) {
//             backgroundColor = '#6c757d'; // Gray for past
//         } else if (moment(event.start).isSame(now, 'day')) {
//             backgroundColor = '#ffc107'; // Yellow for today
//         }
        
//         return {
//             style: {
//                 backgroundColor: backgroundColor,
//                 borderRadius: '4px',
//                 opacity: isPast ? 0.6 : 1,
//                 color: 'white',
//                 border: 'none',
//                 display: 'block',
//                 padding: '2px 5px',
//                 fontSize: '0.85em',
//                 cursor: 'pointer',
//                 transition: 'all 0.2s'
//             }
//         };
//     };

//     // Custom event
//     const CustomEvent = ({ event }) => (
//         <div title={event.title}>
//             <strong>{event.title}</strong>
//             <div style={{ fontSize: '0.8em' }}>
//                 {moment(event.start).format('h:mm A')}
//             </div>
//         </div>
//     );

//     // Custom toolbar
//     const CustomToolbar = (toolbar) => (
//         <div style={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             marginBottom: '10px',
//             padding: '10px',
//             background: '#f8f9fa',
//             borderRadius: '4px'
//         }}>
//             <div>
//                 <Button size="sm" color="secondary" onClick={() => toolbar.onNavigate('PREV')}>
//                     Previous
//                 </Button>
//                 <Button size="sm" color="secondary" onClick={() => toolbar.onNavigate('TODAY')} className="mx-2">
//                     Today
//                 </Button>
//                 <Button size="sm" color="secondary" onClick={() => toolbar.onNavigate('NEXT')}>
//                     Next
//                 </Button>
//             </div>
//             <h5 className="mb-0">{moment(toolbar.date).format('MMMM YYYY')}</h5>
//             <Button 
//                 size="sm" 
//                 color="primary"
//                 onClick={() => {
//                     setIsEditMode(false);
//                     setAddClassModal(true);
//                 }}
//             >
//                 <VideoCallIcon style={{ fontSize: '1rem', marginRight: '5px' }} />
//                 Add Class
//             </Button>
//         </div>
//     );

//     // Format date
//     const formatDateTime = (date) => moment(date).format('DD MMM YYYY, hh:mm A');

//     // Debug
//     useEffect(() => {
//         console.log("LiveClasses:", liveClasses);
//     }, [liveClasses]);

//     return (
//         <>
//             <div className="row mt-2">
//                 <div className="col-md-12">
//                     {/* ✅ Calendar */}
//                     <div style={{ height: "600px", background: 'white', padding: '15px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
//                         {loader && !liveClasses?.length ? (
//                             <div className="text-center py-5">
//                                 <CircularProgress />
//                                 <p className="mt-2">Loading classes...</p>
//                             </div>
//                         ) : (
//                             <Calendar
//                                 localizer={localizer}
//                                 events={liveClasses}
//                                 startAccessor="start"
//                                 endAccessor="end"
//                                 defaultView="month"
//                                 views={['month', 'day', 'agenda']}
//                                 style={{ height: '100%' }}
//                                 eventPropGetter={eventStyleGetter}
//                                 components={{
//                                     toolbar: CustomToolbar,
//                                     event: CustomEvent
//                                 }}
//                                 popup
//                                 onSelectEvent={(event) => {
//                                     console.log("Selected event:", event);
//                                     setSelectedClass(event);
//                                     setViewModal(true);
//                                 }}
//                                 messages={{
//                                     next: "Next",
//                                     previous: "Previous",
//                                     today: "Today",
//                                     month: "Month",
//                                     day: "Day",
//                                     agenda: "Agenda",
//                                     noEventsInRange: "No classes scheduled"
//                                 }}
//                             />
//                         )}
//                     </div>
//                 </div>
//             </div>

//             {/* ✅ View Modal */}
//             <Modal show={viewModal} centered size="lg" onHide={() => setViewModal(false)}>
//                 <Modal.Header closeButton>
//                     <Modal.Title>
//                         <VideoCallIcon style={{ marginRight: '10px', color: '#28a745' }} />
//                         Class Details
//                     </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     {selectedClass && (
//                         <div>
//                             <h4 className="mb-3" style={{ color: '#28a745' }}>{selectedClass.title}</h4>
                            
//                             <div className="mb-3">
//                                 <p><AccessTimeIcon style={{ marginRight: '10px', color: '#666' }} /> 
//                                     <strong>Date & Time:</strong> {formatDateTime(selectedClass.start)}
//                                 </p>
//                                 <p><SubjectIcon style={{ marginRight: '10px', color: '#666' }} /> 
//                                     <strong>Description:</strong> {selectedClass.description}
//                                 </p>
//                                 <p><LinkIcon style={{ marginRight: '10px', color: '#666' }} /> 
//                                     <strong>Meeting Link:</strong>{' '}
//                                     <a href="#" onClick={(e) => { e.preventDefault(); openClassLink(selectedClass.classLink); }}
//                                        style={{ color: '#28a745', textDecoration: 'underline' }}>
//                                         {selectedClass.classLink}
//                                     </a>
//                                 </p>
//                             </div>

//                             <div className="d-flex gap-2 mt-4">
//                                 <Button color="warning" onClick={() => handleEdit(selectedClass)} className="flex-fill">
//                                     <EditIcon style={{ marginRight: '5px' }} /> Edit
//                                 </Button>
//                                 <Button color="danger" onClick={() => confirmDelete(selectedClass)} className="flex-fill">
//                                     <DeleteIcon style={{ marginRight: '5px' }} /> Delete
//                                 </Button>
//                                 <Button color="success" onClick={() => openClassLink(selectedClass.classLink)} className="flex-fill">
//                                     <VideoCallIcon style={{ marginRight: '5px' }} /> Join
//                                 </Button>
//                             </div>
//                         </div>
//                     )}
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button color="secondary" onClick={() => setViewModal(false)}>Close</Button>
//                 </Modal.Footer>
//             </Modal>

//             {/* ✅ Delete Confirmation Modal */}
//             <Modal show={deleteConfirmModal} centered onHide={() => setDeleteConfirmModal(false)}>
//                 <Modal.Header closeButton>
//                     <Modal.Title className="text-danger">Confirm Delete</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     {classToDelete && (
//                         <>
//                             <p>Are you sure you want to delete this class?</p>
//                             <p><strong>Title:</strong> {classToDelete.title}</p>
//                             <p><strong>Date:</strong> {formatDateTime(classToDelete.start)}</p>
//                             <p className="text-danger mb-0"><strong>This action cannot be undone!</strong></p>
//                         </>
//                     )}
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button color="secondary" onClick={() => setDeleteConfirmModal(false)}>Cancel</Button>
//                     <Button color="danger" onClick={handleDelete}>Delete</Button>
//                 </Modal.Footer>
//             </Modal>

//             {/* ✅ Add/Edit Modal */}
//             <Modal show={addClassModal} size="lg" centered onHide={handleModalClose}>
//                 <Modal.Header closeButton>
//                     <Modal.Title>
//                         {isEditMode ? 'Edit Live Class' : 'Create New Live Class'}
//                     </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <Row className="mb-3">
//                         <label className="col-md-3 col-form-label">Class Title *</label>
//                         <div className="col-md-9">
//                             <input
//                                 type="text"
//                                 className="form-control"
//                                 value={liveClass.title}
//                                 placeholder="Enter Class Title"
//                                 onChange={(e) => setLiveClass(p => ({ ...p, title: e.target.value }))}
//                             />
//                             {!liveClass.title && <small className="text-danger">Required</small>}
//                         </div>
//                     </Row>

//                     <Row className="mb-3">
//                         <label className="col-md-3 col-form-label">Description *</label>
//                         <div className="col-md-9">
//                             <textarea
//                                 className="form-control"
//                                 value={liveClass.description}
//                                 placeholder="Enter Description"
//                                 rows="3"
//                                 onChange={(e) => setLiveClass(p => ({ ...p, description: e.target.value }))}
//                             />
//                             {!liveClass.description && <small className="text-danger">Required</small>}
//                         </div>
//                     </Row>

//                     <Row className="mb-3">
//                         <label className="col-md-3 col-form-label">Meeting Link *</label>
//                         <div className="col-md-9">
//                             <input
//                                 type="url"
//                                 className="form-control"
//                                 value={liveClass.classLink}
//                                 placeholder="Enter Meeting Link"
//                                 onChange={(e) => setLiveClass(p => ({ ...p, classLink: e.target.value }))}
//                             />
//                             {!liveClass.classLink && <small className="text-danger">Required</small>}
//                         </div>
//                     </Row>

//                     <Row className="mb-3">
//                         <label className="col-md-3 col-form-label">Date & Time *</label>
//                         <div className="col-md-9">
//                             <input
//                                 type="datetime-local"
//                                 className="form-control"
//                                 value={liveClass.classTime}
//                                 min={moment().format("YYYY-MM-DDTHH:mm")}
//                                 onChange={(e) => setLiveClass(p => ({ ...p, classTime: e.target.value }))}
//                             />
//                             {!liveClass.classTime && <small className="text-danger">Required</small>}
//                         </div>
//                     </Row>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button color="secondary" onClick={handleModalClose}>Cancel</Button>
//                     <Button 
//                         color="success" 
//                         onClick={handleClassSave}
//                         disabled={!liveClass.title || !liveClass.description || !liveClass.classLink || !liveClass.classTime}
//                     >
//                         {isEditMode ? 'Update Class' : 'Create Class'}
//                     </Button>
//                 </Modal.Footer>
//             </Modal>
//         </>
//     );
// };

// export default LClass;